export default "__VITE_ASSET__DJaWDgKd__"